import { render, staticRenderFns } from "./SCteVeiculoEstrutura.vue?vue&type=template&id=abfefee6"
import script from "./SCteVeiculoEstrutura.vue?vue&type=script&lang=js"
export * from "./SCteVeiculoEstrutura.vue?vue&type=script&lang=js"
import style0 from "./SCteVeiculoEstrutura.vue?vue&type=style&index=0&id=abfefee6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports